import { useLocation } from 'react-router-dom'
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import PageContent from '../components/ui/PageContent'
import PageHeader from '../components/ui/PageHeader'
const WorkerFuturePage = () => {
    const { pathname } = useLocation()
    const forms = pathname === '/worker/forms'
    return <div><Header /><div className="pageShell"><Sidebar /><PageContent className="pageContent"><PageHeader title={forms ? 'Forms' : 'Invoices'} subtitle={forms ? 'Your workplace forms and documents' : 'Your invoices and payment information'} /></PageContent></div></div>
}
export default WorkerFuturePage
